module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fileName) ? _c('path-line', {
    attrs: {
      "file-name": _vm.fileName
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.introText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-19efcc46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 1445
// module chunks = 1